import { useRef } from 'react';
import { ProductCard } from '@/components/product';
import { HeroSection } from '@/components/ui';
import { useProduct } from '@/context';
import styles from './ProductSelectionScreen.module.css';

export function ProductSelectionScreen() {
  const { products, selectProduct } = useProduct();
  const gridRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.screen}>
      <div className={styles.container}>
        <HeroSection />

        <header className={styles.header}>
          <h1 className={styles.title}>Choose Your Product</h1>
          <p className={styles.subtitle}>
            Select a product to start designing ({products.length} products)
          </p>
        </header>

        <div
          ref={gridRef}
          id="product-grid"
          className={styles.grid}
          role="list"
          aria-label="Available products"
        >
          {products.map((product) => (
            <div key={product.id} role="listitem">
              <ProductCard product={product} onSelect={selectProduct} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
